import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import { roleHome } from '../lib/constants';

// Atterraggio per ruolo dopo l'autenticazione: l'OP va alla shell mobile,
// gli altri alla dashboard. Renderizzato dentro ProtectedRoute (auth garantita).
export default function RoleHomeRedirect() {
  const user = useAuthStore((s) => s.user);
  return <Navigate to={roleHome(user?.role)} replace />;
}
